import styled from 'styled-components';

import { sizeUp } from '~/theme';

export const Container = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: sizeUp('15rem', ['md', '25rem']),

  '> *': {
    inlineSize: `clamp(150rem, 100%, 275rem)`,
    blockSize: '245rem',
  },
});
